module.exports = __webpack_public_path__ + "media/custom/images/img45-de6d8b5361dc5cb16d9b2aefd670d301.jpg";